import {
  type InferOutput,
  minLength,
  number,
  object,
  pipe,
  string
} from 'valibot'

import { VALIDATION_MESSAGES } from '@/constants/common/validation.constants'

export const CreatePartnerToSubPartnerDtoSchema = object({
  partnerId: number(VALIDATION_MESSAGES.REQUIRED_ITEM),
  subPartner: object({
    name: pipe(string(), minLength(1, VALIDATION_MESSAGES.REQUIRED_ITEM))
  })
})

export type CreatePartnerToSubPartnerDto = InferOutput<
  typeof CreatePartnerToSubPartnerDtoSchema
>
